export const RESERVE_ONLINE_ENABLED = true;